import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { supportedLanguages } from "utils/languages";
import { currentLanguageRecoil } from "./atom";
import { useEffect } from "react";

export function useLanguageTranslator() {
  const { t, i18n } = useTranslation();

  const [currentLanguage, setCurrentLannguage] = useRecoilState(
    currentLanguageRecoil
  );

  useEffect(() => {
    if (Object.keys(supportedLanguages).includes(currentLanguage)) {
      i18n.changeLanguage(currentLanguage);
      localStorage.setItem("language", currentLanguage);
    }
  }, [currentLanguage]);

  function changeLanguage(languageCode) {
    if (Object.keys(supportedLanguages).includes(languageCode)) {
      setCurrentLannguage(languageCode);
    }
  }

  return { translator: t, i18n, currentLanguage, changeLanguage };
}
